import React from 'react';
import { Button } from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';
import { useAppSelector } from '../../../../../app/store';
import { useDownloadDrgsMutation } from '../../../../../services/ContractService';

interface DrgDownloadCsvProps {
  disabled?: boolean;
}

const DrgDownloadCsv: React.FC<DrgDownloadCsvProps> = ({ disabled = false }) => {
  const selectedFeeSchedule = useAppSelector((state) => state.contract.currentFeeSchedule);
  const [downloadDrgs, { isLoading: isDownloading }] = useDownloadDrgsMutation();

  const handleDownload = async () => {
    if (!selectedFeeSchedule?.id) {
      console.warn('No fee schedule selected');
      return;
    }
    
    try {
      const blob = await downloadDrgs({
        feeScheduleId: selectedFeeSchedule.id
      }).unwrap();
      
      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Drgs_FeeSchedule_${selectedFeeSchedule.id}_${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Download failed:', err);
    }
  };

  const isDisabled = disabled || !selectedFeeSchedule?.id || isDownloading;

  return (
    <Button
      variant="outlined"
      startIcon={<DownloadIcon />}
      onClick={handleDownload}
      size="small"
      disabled={isDisabled}
    >
      Download CSV
    </Button>
  );
};

export default DrgDownloadCsv;
